export default __webpack_public_path__ + "static/media/photo--lg--group-jump2.34c2cb4c.jpg";